import {api} from '../../../../configs/index';
import {getUrl} from "../../../../services/helper";
import {baseAxios} from "../../../../services/api";
import {setIsLoading, setTableLoading} from "../loading/actions";
import {SET_TASK_LIST, SET_TASK_LIST_META, SET_TASK_LIST_FILTER_DATA} from "./types";
import {setTaskListFilterParams} from "../filter/actions";

export const setTaskList = payload => async dispatch => dispatch({type: SET_TASK_LIST, payload})
export const setTaskListMeta = payload => async dispatch => dispatch({type: SET_TASK_LIST_META, payload})
export const setTaskListFilterData = payload => async dispatch => dispatch({type: SET_TASK_LIST_FILTER_DATA, payload})

export const getTaskList = ({
                                paginationParams = {
                                    per_page: 25,
                                    page: 1,
                                    order: {
                                        field: null,
                                        sort: 'asc'
                                    }
                                },
                                filterFormData = {},
                            }) => async dispatch => {

    dispatch(setTableLoading(true))

    try {
        const {data} = await baseAxios()
            .get(getUrl(api.leads.taskList), {
                params: {...paginationParams, ...filterFormData}
            })
        dispatch(setTaskList(data.items))
        dispatch(setTaskListMeta(data.meta))
        dispatch(setTaskListFilterData({
            accountManagers: data.account_managers,
            created_by: data.created_by,
            moveTypes: data.move_types,
            taskNames: data.task_names,
        }))
    } catch (e) {
        console.error(e)
    } finally {
        dispatch(setTableLoading(false))
    }
}